import React from 'react'

function Icon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
            <mask
                id="mask0_5569_132770"
                style={{ maskType: 'alpha' }}
                width="24"
                height="24"
                x="0"
                y="0"
                maskUnits="userSpaceOnUse"
            >
                <path fill="#D9D9D9" d="M0 0H24V24H0z"></path>
            </mask>
            <g mask="url(#mask0_5569_132770)">
                <path
                    fill="#1C1B1F"
                    d="M11 17.5a.483.483 0 01-.357-.144.484.484 0 01-.144-.357c0-.142.048-.26.144-.356A.484.484 0 0111 16.5h2c.142 0 .26.048.357.144a.485.485 0 01.143.356c0 .142-.047.26-.143.356a.485.485 0 01-.357.144h-2zM4 6.73a.483.483 0 01-.357-.143.485.485 0 01-.143-.357c0-.142.047-.26.143-.356A.485.485 0 014 5.73h16c.141 0 .26.048.356.144a.485.485 0 01.143.357c0 .142-.047.26-.143.356a.485.485 0 01-.357.143H4zm3 5.385a.483.483 0 01-.357-.144.485.485 0 01-.143-.357c0-.141.047-.26.143-.356A.485.485 0 017 11.115h10c.141 0 .26.048.356.144a.485.485 0 01.143.357c0 .142-.047.26-.143.356a.485.485 0 01-.357.143H7z"
                ></path>
            </g>
        </svg>
    )
}

export default Icon
